module.exports = __webpack_public_path__ + "img/liveTitle2.ad2372b6.png";